import React, { FC, SyntheticEvent, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import dayjs from 'dayjs';

// Styles
import './notification-list.scss';

// Components
import { NotificationItem } from '../notification-item/notification-item';
import { ReportDetailsModal } from '../../../../modals/report-details-modal/report-details-modal';

// Store entities
import { deleteNotifications } from '../../../../store/notifications/notifications.thunks';

// Models
import { INotificationItem } from '../../../../interfaces/notifications.interfaces';

type TNotificationListProps = {
  notifications: INotificationItem[];
  total: number;
  loading?: boolean;
  loadMore?: () => void;
};

export const NotificationList: FC<TNotificationListProps> = (
  { notifications, total, loading = false, loadMore = () => {} }: TNotificationListProps
) => {
  const [deletingId, setDeletingId] = useState<number | null>(null);
  const [viewNotification, setViewNotification] = useState<INotificationItem | null>(null);
  const [openView, setOpenView] = useState<boolean>(false);

  const dispatch = useDispatch<any>();

  const transformDatesObject: { [key: string]: INotificationItem[] } = useMemo(() => {
    const uniqueDates = Array.from(new Set(notifications.map((message) => dayjs(message.notification_created_at).format('DD MMM YYYY'))));
    return uniqueDates.reduceRight((acc, date) => {
      acc[date] = notifications.filter(item => dayjs(item.notification_created_at).isSame(date, 'day'));
      return acc;
    }, {} as { [key: string]: INotificationItem[] });
  }, [notifications]);

  const getDateTitle = (date: string): string => {
    if (dayjs(date).isSame(dayjs(), 'day')) {
      return 'Today';
    }
    if (dayjs(date).isSame(dayjs().subtract(1, 'day'), 'day')) {
      return 'Yesterday';
    }
    return date;
  }

  const toggleViewModal = (): void => {
    setOpenView(!openView);
  }

  const onDeleteNotification = async (notifications_id: number): Promise<void> => {
    setDeletingId(notifications_id);
    await dispatch(deleteNotifications({ notifications_id }));
    setDeletingId(null);
  }

  const onViewNotification = async (notification: INotificationItem): Promise<void> => {
    setViewNotification(notification);
    toggleViewModal();
  }

  const onScrollListHandler = (event: SyntheticEvent): void => {
    const { scrollTop, scrollHeight, offsetHeight } = event.target as HTMLDivElement;
    if ((Math.abs(scrollTop) + offsetHeight + 50 < scrollHeight) || loading || (total <= notifications.length)) return;
    loadMore();
  }

  return (
    <div className="notification-list" onScroll={ onScrollListHandler }>
      {/*<ReportDetailsModal open={ openView } notification={ viewNotification } onCancel={ toggleViewModal }/>*/}

      {
        Object.keys(transformDatesObject).map(date => <div key={ date } className="notification-list--item">
          <div className="item-label">
            { getDateTitle(date) }
          </div>
          <div className="item-notifications">
            {
              transformDatesObject[date].map((notification) =>
                <NotificationItem key={ notification.id }
                                  loading={ notification.id === deletingId }
                                  notification={ notification }
                                  onDelete={ onDeleteNotification }
                                  onView={ onViewNotification }
                />)
            }
          </div>
        </div>)
      }

    </div>
  );
}
